import { Link, NavLink } from 'react-router-dom';
import './Admisiones.css';
import { useLanguage } from '../i18n/LanguageContext';

export default function Admisiones() {
  const { t, lang, toggleLanguage } = useLanguage();

  return (
    <div className="app">
      <header className="page-hero">
        <nav className="nav">
          <Link to="/" className="brand-link">
            <img
              src="/ceam-logo.png"
              className="brand-logo"
              alt="Centro Educativo Adventista de Monteverde"
            />
            <div className="brand-text">
              <span className="brand-title">{t('common.brand')}</span>
              <span className="brand-subtitle">{t('common.schoolName')}</span>
            </div>
          </Link>
          <div className="nav-actions">
            <NavLink to="/" className="btn ghost">{t('nav.home')}</NavLink>
            <NavLink to="/admisiones" className="btn ghost">{t('nav.admissions')}</NavLink>
            <NavLink to="/acerca-de" className="btn ghost">{t('nav.about')}</NavLink>
            <NavLink to="/ubicacion" className="btn ghost">{t('nav.contact')}</NavLink>
            <NavLink to="/voluntariado" className="btn ghost">{t('nav.volunteer')}</NavLink>
            <button type="button" className="btn ghost lang-toggle" onClick={toggleLanguage}>
              {lang === 'es' ? 'EN' : 'ES'}
            </button>
          </div>
        </nav>
      </header>

      <section className="section">
        <h1>{t('admissions.title')}</h1>
        <p className="section-subtitle">{t('admissions.subtitle')}</p>
        <div className="grid-large">
          <article className="card-large">
            <h2>{t('admissions.preschool')}</h2>
            <p>{t('admissions.preschoolDesc')}</p>
            <div className="card-details">
              <h3>{t('admissions.infoTitle')}</h3>
              <ul>
                <li>✓ {t('admissions.info1')}</li>
                <li>✓ {t('admissions.info2')}</li>
                <li>✓ {t('admissions.info3')}</li>
                <li>✓ {t('admissions.info4')}</li>
              </ul>
              <p className="price">{t('admissions.enrollmentFee')}: ₡100.000</p>
              <p className="price">{t('admissions.monthlyFee')}: ₡150.000</p>
              <a href="https://wa.me/50662857770" target="_blank" rel="noopener noreferrer" className="btn primary">
                {t('admissions.requestInfo')}
              </a>
            </div>
          </article>

          <article className="card-large">
            <h2>{t('admissions.primary')}</h2>
            <p>{t('admissions.primaryDesc')}</p>
            <div className="card-details">
              <h3>{t('admissions.infoTitle')}</h3>
              <ul>
                <li>✓ {t('admissions.info5')}</li>
                <li>✓ {t('admissions.info6')}</li>
                <li>✓ {t('admissions.info7')}</li>
                <li>✓ {t('admissions.info8')}</li>
              </ul>
              <p className="price">{t('admissions.enrollmentFee')}: ₡100.000</p>
              <p className="price">{t('admissions.monthlyFee')}: ₡130.000</p>
              <a href="https://wa.me/50662857770" target="_blank" rel="noopener noreferrer" className="btn primary">
                {t('admissions.requestInfo')}
              </a>
            </div>
          </article>
        </div>
      </section>

      <section className="section">
        <h2>{t('admissions.uniformsTitle')}</h2>
        <div className="grid">
          <article className="card">
            <h3>👕 {t('admissions.polo')}</h3>
            <p className="price">₡9.000</p>
          </article>
          <article className="card">
            <h3>🏃 {t('admissions.pe')}</h3>
            <p className="price">₡8.000</p>
          </article>
          <article className="card">
            <h3>📚 {t('admissions.books')}</h3>
            <p>{t('admissions.booksNote')} <a href="https://wa.me/50662857770" target="_blank" rel="noopener noreferrer">+506 6285 7770</a></p>
          </article>
        </div>
      </section>

      <section className="section alt">
        <h2>{t('admissions.programsTitle')}</h2>
        <div className="grid">
          <article className="card">
            <h3>🌍 {t('admissions.program1Title')}</h3>
            <p>{t('admissions.program1Text')}</p>
          </article>
          <article className="card">
            <h3>🤖 {t('admissions.program2Title')}</h3>
            <p>{t('admissions.program2Text')}</p>
          </article>
          <article className="card">
            <h3>📚 {t('admissions.program3Title')}</h3>
            <p>{t('admissions.program3Text')}</p>
          </article>
        </div>
      </section>

      <footer className="footer">
        <p>{t('footer.rights')}</p>
      </footer>
    </div>
  );
}
